import { type HTMLAttributes } from 'react'
import { type FieldValues, useFormContext } from 'react-hook-form'

export interface FormProps<TFieldValues extends FieldValues> extends Omit<HTMLAttributes<HTMLFormElement>, 'noValidate' | 'onSubmit'> {
  onSubmit: (data: TFieldValues) => void
}

export const Form = <TFieldValues extends FieldValues = FieldValues>({ onSubmit, ...props }: FormProps<TFieldValues>) => {
  const formMethods = useFormContext<TFieldValues>()
  return <form {...props} onSubmit={formMethods.handleSubmit(onSubmit)} noValidate />
}
